<template>
  <div class="row">
     <div :class="[validatedSectionClass, generalClass]" class="col-md-12">
      <div class="row" name="nameSection">
      <div class="col-md-10 col-md-offset-1">
      <div style="min-height: 175; max-height: 175; background-color: transparent; overflow: hidden">
      <el-row :gutter="10">
        <el-col :span="checkMediaScreenWidth() ? 24 : (this.$store.state.requirements['middle_name'] ? 8 : 12)">
          <label class="required">
            {{computeReportableCaption($store.state.requirements['first_name']['reportable_name'], fields_en['first_name'], $store.state.lang.value.toLowerCase())}}
          </label><br>
          <el-input id="firstName"
                    size="small"
                    name="firstName"
                    data-vv-as="First Name"
                    v-validate="modelValidations.firstName"
                    v-model="model.firstName"
                    onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }">
          </el-input>
          <div class="default-grey font-small" v-show="getFieldDescription('first_name')" v-html="getFieldDescription('first_name') || ''">
          </div>
          <small class="text-danger" v-show="firstName.invalid">
            {{ getError("firstName") && computeCaption(getError("firstName"), $store.state.lang.value.toLowerCase())}}
          </small>
        </el-col>

        <el-col :span="checkMediaScreenWidth() ? 24 : 8" v-if="this.$store.state.requirements['middle_name']">
          <label :class="checkRequirement('middle_name') ? 'required' : ''">
            {{computeReportableCaption($store.state.requirements['middle_name']['reportable_name'], fields_en['middle_name'], $store.state.lang.value.toLowerCase())}}
          </label><br>
          <el-input id="middleName"
                    size="small"
                    data-vv-as="Middle Name"
                    name="middleName"
                    v-validate="modelValidations.middleName"
                    v-model="model.middleName"
                    onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }">
          </el-input>
          <div class="default-grey font-small" v-show="getFieldDescription('middle_name')" v-html="getFieldDescription('middle_name') || ''">
          </div>
          <small class="text-danger" v-show="middleName.invalid">
            {{ getError("middleName") && computeCaption(getError("middleName"), $store.state.lang.value.toLowerCase())}}
          </small>
        </el-col>

        <el-col :span="checkMediaScreenWidth() ? 24 : (this.$store.state.requirements['middle_name'] ? 8 : 12)">
          <label class="required">
            {{computeReportableCaption($store.state.requirements['last_name']['reportable_name'], fields_en['last_name'], $store.state.lang.value.toLowerCase())}}
          </label><br>
          <el-input id="lastName"
                    size="small"
                    name="lastName"
                    data-vv-as="Last Name"
                    v-validate="modelValidations.lastName"
                    v-model="model.lastName"
                    onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }">
          </el-input>
          <div class="default-grey font-small" v-show="getFieldDescription('last_name')" v-html="getFieldDescription('last_name') || ''">
          </div>
          <small class="text-danger" v-show="lastName.invalid">
            {{ getError("lastName") && computeCaption(getError("lastName"), $store.state.lang.value.toLowerCase())}}
          </small>
        </el-col>
      </el-row>
      </div>
      </div>
    </div>
    <br>
    <div class="row" name="nameSection">
      <div class="col-md-10 col-md-offset-1">
      <div style="min-height: 175; max-height: 175; background-color: transparent; overflow: hidden">
    <el-row :gutter="10" v-if="$store.state.configs.DISPLAY_INTERNATIONAL_CHECK">
        <el-col :span="checkMediaScreenWidth() ? 24 : 12">
          <div >
            <label class="control-label">
              {{computeCaption(this.fields_en['where_are_you_from'], $store.state.lang.value.toLowerCase())}}
            </label>
          </div>
        </el-col>
        <el-col :span="checkMediaScreenWidth() ? 24 : 12" class="nationality-float">
            <el-radio-group size="small"
                placeholder="Single Select"
                v-model="nationality"
                @change="switchInternational()">
              <el-radio-button
                label="US"
                value="US"
                tabindex=0
                :disabled="disabled">
              </el-radio-button>
              <el-radio-button
                label="International"
                value="International"
                tabindex=0
                :disabled="disabled">
                {{computeCaption(this.fields_en['international'], $store.state.lang.value.toLowerCase())}}
              </el-radio-button>
            </el-radio-group>
        </el-col>
      </el-row>
      </div>
      </div>
      </div>
     </div>
  </div>
</template>

<script>
import {Col, Row, Input, Button, RadioGroup, Radio, RadioButton} from 'element-ui'
import {mapFields} from 'vee-validate'
import {TranslationsUtils} from '../../../../utils/Translations'
import {AccessionUtils} from '../../../../utils/AccessionDetailsProcessing'
import {SettingsUtils} from '../../../../utils/SiteConfigurations'
import {LayoutCalculationUtils} from '../../../../utils/LayoutCalculation'
export default {
  name: 'NameSection',
  props: ['configuration', 'triggerNameSectionValidation'],
  components: {
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [RadioButton.name]: RadioButton,
    [Input.name]: Input,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col
  },
  mixins: [
    TranslationsUtils,
    AccessionUtils,
    SettingsUtils,
    LayoutCalculationUtils
  ],
  data () {
    return {
      nameSectionValidation: {
        firstNameValidation: false,
        lastNameValidation: false,
        middleNameValidation: !this.checkRequirement('middle_name')
      },
      generalClass: 'general-inactive-section',
      validatedSectionClass: '',
      disabled: false,
      fields_en: {
        international: 'International',
        first_name: 'First Name',
        middle_name: 'Middle Name',
        last_name: 'Last Name',
        where_are_you_from: 'Where are you from?'
      },
      modelValidations: {
        firstName: {
          min: 2,
          required: true
        },
        lastName: {
          min: 2,
          required: true
        },
        middleName: {
          min: 2,
          required: this.checkRequirement('middle_name')
        }
      },
      model: {
        firstName: '',
        lastName: '',
        middleName: ''
      },
      nationality: 'US'
    }
  },
  methods: {
    computeNameSectionValidation () {
      if (Object.values(this.nameSectionValidation).every(field => field === true)) {
        this.validatedSectionClass = 'validated-section-class'
        this.generalClass = 'general-inactive-section'
      } else {
        this.validatedSectionClass = 'invalid-section-class'
        this.generalClass = 'general-invalid-section'
      }
    },
    test (args) {
      console.log(args)
    },
    validate () {
      this.$store.state.dataForInsurance.first_name = this.model.firstName
      this.$store.state.dataForInsurance.last_name = this.model.lastName
      this.$store.state.dataForInsurance.middle_name = this.model.middleName
      this.$validator.validate()
      if (this.model.firstName === '') {
        document.getElementsByName('firstName')[0].focus()
        return false
      }
      if (this.checkRequirement('middle_name') && this.model.middleName === '') {
        document.getElementsByName('middleName')[0].focus()
        return false
      }
      if (this.model.lastName === '') {
        document.getElementsByName('lastName')[0].focus()
        return false
      }
      if (this.nameSectionValidation.firstNameValidation && this.nameSectionValidation.lastNameValidation && this.nameSectionValidation.middleNameValidation) {
        this.configuration.model.firstName = this.model.firstName
        this.configuration.model.lastName = this.model.lastName
        this.configuration.model.middleName = this.model.middleName
        return true
      }
      return false
    },
    getError (fieldName) {
      return this.errors.first(fieldName)
    },
    switchInternational () {
      if (this.nationality === 'International') {
        this.$store.state.international = true
      } else {
        this.$store.state.international = false
      }
    }
  },
  async beforeMount () {
    this.$store.state.international = false
    let token = localStorage.getItem('token')
    if (token) {
      this.model.firstName = this.$store.state.userData['firstName'] || ''
      this.model.lastName = this.$store.state.userData['lastName'] || ''
      this.model.middleName = this.$store.state.userData['middleName'] || ''
      this.$store.state.nameComponentInsuranceData.lastName = this.$store.state.userData['lastName'] || ''
      this.$store.state.nameComponentInsuranceData.firstName = this.$store.state.userData['firstName'] || ''
      this.$store.state.nameComponentInsuranceData.middleName = this.$store.state.userData['middleName'] || ''
      if (this.model.firstName.length > this.modelValidations.firstName.min - 1) {
        this.nameSectionValidation.firstNameValidation = true
      } else {
        this.nameSectionValidation.firstNameValidation = false
      }
      if (this.model.lastName.length > this.modelValidations.lastName.min - 1) {
        this.nameSectionValidation.lastNameValidation = true
      } else {
        this.nameSectionValidation.lastNameValidation = false
      }
    }
  },
  mounted () {
    if (this.triggerNameSectionValidation === true) {
      this.$watch('nameSectionValidation', this.computeNameSectionValidation, {deep: true})
    }
  },
  computed: {
    firstNameFromTransaction () {
      if (this.$store.state.medicalData.first_name) {
        return this.$store.state.medicalData.first_name
      }
    },
    lastNameFromTransaction () {
      if (this.$store.state.medicalData.last_name) {
        return this.$store.state.medicalData.last_name
      }
    },
    ...mapFields(['firstName', 'lastName', 'middleName'])
  },
  watch: {
    firstNameFromTransaction () {
      this.model.firstName = this.$store.state.medicalData.first_name
    },
    lastNameFromTransaction () {
      this.model.lastName = this.$store.state.medicalData.last_name
    },
    'model.firstName': {
      handler: function (before, after) {
        this.$store.state.insuranceData.firstName = this.model.firstName
        if (this.model.firstName.length > this.modelValidations.firstName.min - 1) {
          this.nameSectionValidation.firstNameValidation = true
        } else {
          this.nameSectionValidation.firstNameValidation = false
          this.validatedSectionClass = 'invalid-section-class'
          this.generalClass = 'general-invalid-section'
        }
        if (this.$store.state.relationship === 'Self') {
          let nameObject = {
            firstName: this.model.firstName,
            lastName: this.model.lastName,
            middleName: this.model.middleName
          }
          this.$store.state.nameComponentInsuranceData = nameObject
        }
        this.configuration.model.firstName = this.model.firstName
      }
    },
    'model.lastName': {
      handler: function (before, after) {
        this.$store.state.insuranceData.lastName = this.model.lastName
        if (this.model.lastName.length > this.modelValidations.lastName.min - 1) {
          this.nameSectionValidation.lastNameValidation = true
        } else {
          this.nameSectionValidation.lastNameValidation = false
          this.validatedSectionClass = 'invalid-section-class'
          this.generalClass = 'general-invalid-section'
        }
        if (this.$store.state.relationship === 'Self') {
          let nameObject = {
            firstName: this.model.firstName,
            lastName: this.model.lastName,
            middleName: this.model.middleName
          }
          this.$store.state.nameComponentInsuranceData = nameObject
        }
        this.configuration.model.lastName = this.model.lastName
      }
    },
    'model.middleName': {
      handler: function (before, after) {
        this.$store.state.insuranceData.middleName = this.model.middleName
        if (this.checkRequirement('middle_name')) {
          if (this.model.middleName.length < this.modelValidations.middleName.min) {
            this.nameSectionValidation.middleNameValidation = false
            this.validatedSectionClass = 'invalid-section-class'
            this.generalClass = 'general-invalid-section'
          } else {
            this.nameSectionValidation.middleNameValidation = true
          }
        } else {
          this.nameSectionValidation.middleNameValidation = true
        }
        if (this.$store.state.relationship === 'Self') {
          let nameObject = {
            firstName: this.model.firstName,
            lastName: this.model.lastName,
            middleName: this.model.middleName
          }
          this.$store.state.nameComponentInsuranceData = nameObject
        }
        this.configuration.model.middleName = this.model.middleName
      },
      deep: true
    },
    '$store.state.relationship': {
      handler: function (after, before) {
        if (this.$store.state.relationship === 'Self') {
          let nameObject = {
            firstName: this.model.firstName,
            lastName: this.model.lastName,
            middleName: this.model.middleName
          }
          this.$store.state.nameComponentInsuranceData = nameObject
        }
      }
    },
    '$store.state.userData.firstName': {
      handler (value) {
        this.model.firstName = value
      }
    },
    '$store.state.userData.lastName': {
      handler (value) {
        this.model.lastName = value
      }
    },
    '$store.state.userData.middleName': {
      handler (value) {
        this.model.middleName = value
      }
    },
    '$store.state.requirements': {
      handler: function (after, before) {
        this.modelValidations.middleName.required = this.checkRequirement('middle_name')
        this.nameSectionValidation.middleNameValidation = !this.checkRequirement('middle_name')
        this.$watch('nameSectionValidation', this.computeNameSectionValidation, {deep: true})
      },
      deep: true
    },
    'triggerNameSectionValidation': {
      handler: function (after, before) {
        this.$watch('nameSectionValidation', this.computeNameSectionValidation, {deep: true})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/sass/paper/_variables.scss';
.padding-small {
  padding-right: 2px !important;
}

.general-inactive-section {
  transition: 0.4s;
}
.general-inactive-section:focus-within {
  border-left-color: $primary-color !important;
}
.nationality-float{
    text-align: right;
}
@media screen and (max-width: 991px) {
  .nationality-float{
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Utils/NameSection.vue